import React, { forwardRef, ForwardRefRenderFunction } from 'react';
import Container, { ContainerProps } from '../Container/Container';
import { Spacing } from '../../../theme';

interface CardProps extends Omit<ContainerProps, 'shadow' | 'bordered' | 'radius' | 'bgColor' | 'padding'> {
  shadow?: boolean;
  variant?: 'default' | 'elevated';
  padding?: Spacing | string;
}

const Card: ForwardRefRenderFunction<HTMLDivElement, CardProps> = (
  { children, padding = 'md', shadow = true, variant = 'default', style, ...props },
  ref
) => {
  // Handle custom padding values that aren't theme spacing
  const isCustomPadding =
    typeof padding === 'string' && !['none', 'xxs', 'xs', 'sm', 'base', 'md', 'lg', 'xl', 'xxl'].includes(padding);

  const containerProps: ContainerProps = {
    ...props,
    children,
    shadow: shadow ? (variant === 'elevated' ? 'lg' : 'sm') : undefined,
    bordered: true,
    radius: 'md',
    bgColor: 'white',
  };

  if (isCustomPadding) {
    // Use custom padding via style prop
    containerProps.style = {
      padding,
      ...style,
    };
  } else {
    // Use theme spacing
    containerProps.padding = padding as Spacing;
    containerProps.style = style;
  }

  return (
    <Container {...containerProps} ref={ref}>
      {children}
    </Container>
  );
};

export default forwardRef(Card);
